<mat-card appearance="outlined" style="display: flex; flex-direction: row; padding: 10px;">
    <div style="display: flex; justify-content: center;  flex-direction: column; flex-grow: 1;">

        <div style="display: flex; flex-direction: row;">


            <div style="color: grey;font-size: 16px; margin-right: 10px;">
                {{notiz.createdAt | date: 'dd.MM.yyyy - HH:mm'}} | {{glo.getUserNameMitId(notiz.createdBy)}}
                <span *ngIf="notiz.updatedAt"> |&nbsp;zuletzt bearbeitet: {{notiz.updatedAt | date: 'dd.MM.yyyy - HH:mm'}}</span>
            </div>
            <div style="display: flex; flex-grow: 1;">
            </div>
        </div>
        <div style="display: flex; margin-bottom: 10px;" [innerHTML]="(glo.getLines(notiz.text))| safehtml">
        </div>

    </div>

    <div style="display: flex;height: 60px; align-items: center; justify-content: center; ">
        <button mat-icon-button style="margin-left: 15px;" (click)="archivNotiz(true)"
            *ngIf="!notiz.archiv && (notiz.createdBy === authService.getUid() || (firebaseService.admin | async)?.superAdmin)">
            <mat-icon>archive</mat-icon>
        </button>
        <button mat-icon-button style="margin-left: 15px;" (click)="archivNotiz(false)"
            *ngIf="notiz.archiv && (notiz.createdBy === authService.getUid() || (firebaseService.admin | async)?.superAdmin)">
            <mat-icon>unarchive</mat-icon>
        </button>
        <button mat-icon-button style="margin-left: 15px;" (click)="editNotiz()"
            *ngIf="notiz.createdBy === authService.getUid()">
            <mat-icon>edit</mat-icon>
        </button>
    </div>

</mat-card>